// countries who do not require a last name
export const noLastNameRequired = ["IND", "MYS", "IDN"];

// all possible visa types
export const visaTypes = [
  { value: "E1", text: "E-1 Trader" },
  { value: "E2", text: "E-2 Investor" },
  { value: "E3", text: "E-3 Work" },
  { value: "F1", text: "F-1 Student" },
  { value: "H1B", text: "H-1B Work" },
  { value: "TN1", text: "TN1 Work" },
  { value: "O1", text: "O-1 Work" },
  { value: "J1", text: "J-1 Student" },
  { value: "L1", text: "L-1 Work" },
  { value: "OTHER", text: "Other" },
];

export const CUSTOMER_AGREEMENT_REVISION = "23.2025.05";

export const FUNDING_SOURCE = [
  { value: "employment_income", label: "Employment Income" },
  { value: "business_income", label: "Business Income" },
  { value: "inheritance", label: "Inheritance" },
  { value: "investments", label: "Investments" },
  { value: "savings", label: "Savings" },
  { value: "family", label: "Family" },
];
